import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";

import { Popup, PopupProps } from "lib/classes/popup";
import { getLocaleString } from "lib/localization/vendor";
import { assetURL } from "lib/utilities/asset";

const GoogleMapViewPopup = new Popup({
	title: () => getLocaleString("gmapview"),
	styleContainer: {padding: 1},
	style: {maxWidth: 'revert', maxHeight: 'revert'},
	render: function() {
		// Lat and long co-ordinates
		const lat:number = this.get('lat');
		const lng:number = this.get('lng');
		const externalURL:string = this.get('url');
		const feature:Feature<Geometry> = this.get('feature');
		const notes:string = feature?.get?.('Notes') || getLocaleString('nonotes');
		const mapMode:string = this.get('map-mode') || 'streetview';
		const mapType:string = this.get('map-type');
		
		const locKey:string = mapMode == 'streetview' ? 'location' : 'center';
		
		// Google Maps API key
		const API_KEY:string = 'AIzaSyBVj7xk4dwm42ystFa4NdeIaq3AITO4NoI';
		
		// iframe URL
		let baseUrl:string = `https://www.google.com/maps/embed/v1/${mapMode}`;
		let params:URLSearchParams = new URLSearchParams();
		
		params.set('key', API_KEY);
		params.set(locKey, `${lat},${lng}`);
		
		if(mapType)
			params.set('maptype', mapType);
		
		if(mapType == 'satellite')
			params.set('zoom', '19');
		
		// Covert to final full url
		const fullUrl:URL = new URL(baseUrl);
		fullUrl.search = params.toString();
		
		const url:string = fullUrl.href;
		
		console.log(url);
		
		const maxWidth:number = 800;
		const maxHeight:number = 600;
		
		const aspectRatio:number = maxWidth / maxHeight;
		
		const w:number = _dimensions.width > 800 ? (_dimensions.width * 0.6) : (_dimensions.width - 20);
		
		let width:number = w > maxWidth ? maxWidth : w;
		let height:number = width / aspectRatio;
		
		if(height > _dimensions.height - 150)
			height = _dimensions.height - 150;
		
		const drawEditFeature = () => (
			<a href='javascript:;' onClick={() => _ui.autoSelectEditFeatures([feature])}>
				<img src={assetURL("assets/images/edit.png")} className="ql-result__icon" style={{paddingRight: 5}} /> 
				{getLocaleString('editdetails')}
			</a>
		)
		const drawDeleteFeature = () => {
			const deleteMe = () => {
				_ui.showConfirm(getLocaleString('confirmdelete', ['1']), () => {
					_events.invoke('remove-feature', feature);
					_ui.closePopupOf(this);
				});
			}
			
			return (
				<a href='javascript:;' onClick={deleteMe}>
					<img src={assetURL("assets/images/bin.png")} className="ql-result__icon" style={{paddingRight: 5}} /> 
					{getLocaleString('delete')}
				</a>
			)
		}
		const drawNotes = () => {
			if(!notes || !feature)
				return;
			
			return (
				<div style={{padding: 10, paddingBottom: 20}}>
					<div style={{paddingTop: 10}}>
						<b>{getLocaleString('notes')}</b>
						
						<span style={{paddingLeft: 10}}>
							{drawEditFeature()}
							{drawDeleteFeature()}
						</span>
					</div>
					<div>{notes}</div>
				</div>
			)
		}
		const drawLinks = () => {
			const drawOpenExternal = () => (
				<a href={externalURL} target='_blank'>
					<img src={assetURL("assets/images/external.png")} className="ql-result__icon" style={{paddingRight: 5}} /> 
					{getLocaleString('opennewtab')}
				</a>
			)
			
			return (
				<div style={{position: 'absolute', right: 10}}>
					{drawOpenExternal()}
				</div>
			)
		}
		
		return (
			<>
				<iframe
					src={url}
					width={width}
					height={height}
					style={{border: 0}}
					loading="lazy"
				>
				</iframe>
				
				<div style={{width: '100%', minHeight: 30}}>
					{drawLinks()}
					{drawNotes()}
				</div>
			</>
		)
	}
});

export default GoogleMapViewPopup;